import { bootstrapTheme } from './theme';

bootstrapTheme();
